import state from './shade-finder-state'
import getters from './shade-finder-getters'
import actions from './shade-finder-actions'
import mutations from './shade-finder-mutations'

/**
 * Here, we simply aggregate the definitions laid
 * out in each of the state, getter, action and
 * mutation files within this Vuex module.
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
